import { ClientPolicyReportRequestDTO } from '@core/pages/new-business-register/api'
export class ClientPolicyReportDTO implements ClientPolicyReportRequestDTO {
  type: ClientPolicyReportRequestDTO.type = ClientPolicyReportRequestDTO.type.PRODUCTION_MTD_PERSONAL
  startDate?: number = null
  endDate?: number = null
  issuers?: string[] = []
  advisersList?: string[] = []
  nbrApplicationStatus?: string = null
  dateFilteringSelection: ClientPolicyReportRequestDTO.dateFilteringSelection = ClientPolicyReportRequestDTO.dateFilteringSelection.OPS_APPROVAL_DATE;
  fileFormatType = 'PDF'
}
